import { Component, inject } from '@angular/core';
import { UserInfo } from '../connects/connects';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule,CommonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  message:string;
  private router = inject(Router);

  
  
  public authService=inject(AuthService) ;
  error: boolean;
  
  userForm=new FormGroup({
    password: new FormControl('',Validators.required),
    email:new FormControl('',[Validators.required,Validators.email])
  })
  
  public onSubmit(){
    if(this.userForm.valid){
      const userinfo:UserInfo={
        username: this.userForm.value.email,
        password:  this.userForm.value.password
      }
      this.loginBackend(userinfo);
    }
   
  
  
    }
  
    private loginBackend(churchUser:UserInfo){
    this.authService.login(churchUser);
    }
}
